import Badge from "react-bootstrap/Badge";

type Props = {
	classNameLabel?: string;
	classNameCount?: string;
	color: string;
	label: string;
	count: number;
};

export function AccessBadge({ classNameLabel, classNameCount, color, label, count }: Props) {
	return (
		<Badge className={`${classNameLabel} position-relative d-inline-block m-1`} bg={color}>
			{label}
			{count > 0 && (
				<span
					className={`${classNameCount} position-absolute top-0 start-100 translate-middle badge rounded-pill `}
				>
					{count}
				</span>
			)}
		</Badge>
	);
}
